import { $, $$ } from '../../helpers/shortcuts';
import { getTriggers } from '../../helpers/triggers';
import { dispatchEvent } from '../../helpers/events';

function getElements() {
  const header = $('.header');
  const subnavs = $$('.header-nav-secondary');
  return { header, subnavs };
}

function initializeEventListeners({ triggersL1 }) {
  triggersL1.forEach((trigger) =>
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      onSubnavL1Clicked(trigger);
    }),
  );
}

function onSubnavL1Clicked(trigger) {
  const menuId = trigger.parentNode.getAttribute('data-menuid');
  const menuIdL1 = trigger.getAttribute('data-menuid-l1');

  dispatchEvent({
    eventName: 'select-subnav-L1',
    node: document,
    detail: { menuId, menuIdL1, dispatchedBy: 'headerNav' },
  });
}

function initializeHeaderNav() {
  const { header } = getElements();
  if (!header) return;

  const triggersL1 = getTriggers('subnav-L1');
  initializeEventListeners({ triggersL1 });
}

export { initializeHeaderNav };
